'use strict'

module.exports = (config) => {
  return () => ({
    host: config.host,
    port: config.port
  })
}



//////////////////
// WEBPACK FOOTER
// ./src/util/get-endpoint-config.js
// module id = 580
// module chunks = 0